import { useTranslation as useReactI18nextTranslation } from 'react-i18next'
import { SupportedLanguage } from '../config'

// Re-export the useTranslation hook with proper typing and safety checks
export function useTranslation() {
  const { t, i18n } = useReactI18nextTranslation()

  // Safe translation function that handles undefined t
  const safeT = (key: string, options?: any): string => {
    try {
      if (!t) {
        console.warn('Translation function not ready, returning key:', key)
        return key
      }
      const result = t(key, options)
      return typeof result === 'string' ? result : key
    } catch (error) {
      console.warn('Translation error for key:', key, error)
      return key
    }
  }

  // Helper function to change language
  const changeLanguage = (language: SupportedLanguage) => {
    return i18n?.changeLanguage?.(language)
  }

  // Get current language
  const currentLanguage = (i18n?.language || 'en') as SupportedLanguage

  // Check if language is ready
  const isReady = i18n?.isInitialized || false

  return {
    t: safeT,
    i18n,
    changeLanguage,
    currentLanguage,
    isReady,
  }
}

// Export the translation function type for external use
export type TranslationFunction = ReturnType<typeof useTranslation>['t'] 